import { createSelector } from "reselect";

import type { LegCardItem } from "@app/modules/results/helpers/results-filter";
import { result_filter_options } from "@app/modules/results/helpers/results-filter";

import { getDataForCombinedFilters } from "./get-data-for-combined-filters";
import { FacetedSearch } from "../../helpers/faceted-search";
import { getSelectedAwardWinnersOnly } from "../get-selected-award-winners-only";
import { getSelectedClasses } from "../get-selected-classes";
import { getSelectedDepartureTimeRanges } from "../get-selected-departure-range";
import { getSelectedDestinationPointsOfInterests } from "../get-selected-destination-points-of-interests";
import { getSelectedHasETicket } from "../get-selected-has-eticket";
import { getSelectedIsDirectOnly } from "../get-selected-is-direct-only";
// import {
//   getSelectedDestinations,
//   getSelectedOrigins
// } from "../get-selected-locations";
import { getSelectedOperatorIds } from "../get-selected-operator-ids";
import { getSelectedOriginPointsOfInterests } from "../get-selected-origin-points-of-interests";
import { getSelectedProfileIds } from "../get-selected-profile-ids";
import { getSelectedVehicleType } from "../get-selected-vehicle-type";

export const getFilteredLegCardIdsByCombinedFilters = createSelector(
  [
    getDataForCombinedFilters,
    getSelectedDepartureTimeRanges,
    getSelectedOperatorIds,
    getSelectedProfileIds,
    getSelectedHasETicket,
    getSelectedIsDirectOnly,
    getSelectedVehicleType,
    // getSelectedOrigins,
    // getSelectedDestinations,
    getSelectedAwardWinnersOnly,
    getSelectedClasses,
    getSelectedOriginPointsOfInterests,
    getSelectedDestinationPointsOfInterests
  ],
  (
    data,
    selected_departure_time_ranges,
    selected_operator_ids,
    selected_profile_ids,
    selected_has_e_ticket,
    selected_is_direct_only,
    selected_vehicle_type,
    // selected_origins,
    // selected_destinations,
    selected_award_winners_only,
    selected_salon_cama,
    selected_origin_poi,
    selected_destination_poi
  ) => {
    const faceted_search = new FacetedSearch<LegCardItem>();

    try {
      return (
        faceted_search
          .setOptions(result_filter_options)
          .setData(data)
          .setFilter("departure_time", selected_departure_time_ranges)
          .setFilter("operator_ids", selected_operator_ids)
          .setFilter("profile_ids", selected_profile_ids)
          .setFilter("has_e_ticket", selected_has_e_ticket)
          .setFilter("is_direct_only", selected_is_direct_only)
          .setFilter("vehicle_type", selected_vehicle_type)
          // .setFilter("origin", selected_origins)
          // .setFilter("destination", selected_destinations)
          .setFilter("is_award_winner", selected_award_winners_only)
          .setFilter("classes", selected_salon_cama)
          .setFilter("origin_poi", selected_origin_poi)
          .setFilter("destination_poi", selected_destination_poi)
          .search()
          .getSearchResult()
          .map(result => result.id)
      );
    } catch (e) {
      // TODO UDMV4 make sure filters are working
      return [];
    }
  }
);
